import type { ReactElement } from "react";
import { ActionLabel } from "../../../../../../../utils/constants";
import { getIntegrationLogo } from "../../../../../../../utils/integration-logo";
import { Icon } from "@smartsuite/react-ui/lib";
import { SolutionColorVariables } from "@smartsuite/types";
import type { RecordsSourceOption } from "../../utils";

const getActionIconProps = (
  actionId?: string,
): { name: string; size?: "S" | "M" } => {
  switch (actionId) {
    case ActionLabel.createRecord:
      return { name: "plus-circle" };
    case ActionLabel.updateRecord:
      return { name: "edit-smaller" };
    case ActionLabel.deleteRecord:
      return { name: "trash" };
    case ActionLabel.sendEmail:
    case ActionLabel.sendEmailFromSmartsuite:
      return { name: "email", size: "S" };
    case ActionLabel.findRecords:
      return { name: "search" };
    case ActionLabel.mergeRecords:
      return { name: "merge", size: "S" };
    case ActionLabel.generatePdf:
    case ActionLabel.docsautomator:
      return { name: "pdf" };
    case ActionLabel.commentRecord:
      return { name: "comments" };
    case ActionLabel.sendWebhook:
      return { name: "webhook" };
    case ActionLabel.sendNotification:
      return { name: "bell" };
    default:
      return { name: "edit-smaller" };
  }
};

export const ActionLogo = ({
  option,
}: {
  option: RecordsSourceOption;
}): ReactElement => {
  const isWebhook =
    option.actionReference?.actionId === ActionLabel.sendWebhook;

  if (isWebhook) {
    const LogoWebhook = getIntegrationLogo(
      option.actionReference?.integrationId ?? "",
    );
    return <LogoWebhook data-testid="action-logo" />;
  }

  const actionIcon = getActionIconProps(option.actionReference?.actionId);

  return (
    <Icon
      data-testid="action-logo"
      size={option.type === "trigger" ? "M" : (actionIcon.size ?? "M")}
      name={option.type === "trigger" ? "lightning" : actionIcon.name}
      color={SolutionColorVariables.sc1}
      width={16}
      height={16}
    />
  );
};
